var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 100,
    viewBox: "0 0 109 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3516 36.5292H20.3867C26.0435 20.8693 40.9045 9.26814 58.7696 9.26814C81.1729 9.26814 99.3576 27.6127 99.3576 49.8562C99.3576 72.0997 81.1729 90.604 58.9294 90.604C43.2694 90.604 29.7827 81.6555 23.1991 68.9677H12.2371C19.7475 87.3122 37.6127 100 58.482 100C86.0627 100 108.466 77.5967 108.466 50.016C108.466 22.4353 86.0307 0 58.45 0C35.7271 0 16.296 15.3723 10.3516 36.5292Z",
    fill: "#007FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.177 52.1896C81.177 56.2484 77.8852 59.7 73.6666 59.7C69.448 59.7 66.1562 56.4082 66.1562 52.1896C66.1562 47.971 69.448 44.6792 73.6666 44.6792C77.8852 44.839 81.177 48.1308 81.177 52.1896Z",
    fill: "#007FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2267 41.0684H36.8234C34.9378 41.0684 33.0522 42.6344 33.0522 44.8395H7.35711C5.47152 44.8395 3.58594 46.4055 3.58594 48.6107V56.1211C3.58594 58.0067 5.15193 59.8923 7.35711 59.8923H62.9979V44.9993C62.5185 42.9539 61.1123 41.0684 59.2267 41.0684Z",
    fill: "#007FAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04538 63.1504H83.7009C84.7875 63.1504 85.7462 64.0772 85.7462 65.1958C85.7462 66.3143 84.8194 67.2412 83.7009 67.2412H2.04538C0.958771 67.2412 0 66.3143 0 65.1958C0 64.0772 0.798975 63.1504 2.04538 63.1504Z",
    fill: "#007FAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04538 63.1504H83.7009C84.7875 63.1504 85.7462 64.0772 85.7462 65.1958C85.7462 66.3143 84.8194 67.2412 83.7009 67.2412H2.04538C0.958771 67.2412 0 66.3143 0 65.1958C0 64.0772 0.798975 63.1504 2.04538 63.1504Z",
    fill: "#007FAD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_96036",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 63,
    width: 86,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04538 63.1504H83.7009C84.7875 63.1504 85.7462 64.0772 85.7462 65.1958C85.7462 66.3143 84.8194 67.2412 83.7009 67.2412H2.04538C0.958771 67.2412 0 66.3143 0 65.1958C0 64.0772 0.798975 63.1504 2.04538 63.1504Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_96036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 63.1504H0V67.2092H85.7143V63.1504Z",
    fill: "#007FAD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.0c9752c6c1ecb024f3f045388b70a7a2.svg";
export { ForwardRef as ReactComponent };